import React from 'react';

interface DashboardHeaderProps {
  currentUser: string;
  currentUserRole: string;
  onLogout: () => void;
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({ currentUser, currentUserRole, onLogout }) => {
  const getRoleDisplay = (role: string) => {
    switch (role) {
      case 'super_admin': return { text: 'Super Admin', bg: 'bg-red-400 text-red-900' };
      case 'admin_bank': return { text: 'Administrateur de la banque', bg: 'bg-yellow-400 text-yellow-900' };
      case 'agent_saisie': return { text: 'Agent de Saisie', bg: 'bg-green-400 text-green-900' };
      case 'auditeur': return { text: 'Auditeur', bg: 'bg-purple-400 text-purple-900' };
      case 'conformité': return { text: 'Conformité', bg: 'bg-orange-400 text-orange-900' };
      default: return { text: 'Superviseur', bg: 'bg-blue-300 text-blue-900' };
    }
  };

  const roleInfo = getRoleDisplay(currentUserRole);

  return (
    <div className="mb-6 sm:mb-8">
      <div className="bg-gradient-to-r from-blue-600 via-blue-700 to-indigo-800 rounded-xl sm:rounded-2xl shadow-xl p-4 sm:p-6 mb-4 sm:mb-6">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4">
          <div className="w-full lg:w-auto">
            <h1 className="text-2xl sm:text-3xl font-bold text-white mb-1">
              S-Collect
              <span className="block text-lg sm:text-xl font-normal text-blue-100 mt-1 sm:mt-2">
                Tableau de bord administrateur
              </span>
            </h1>
            <div className="flex items-center bg-white/20 backdrop-blur-sm rounded-full px-3 sm:px-4 py-1 sm:py-2 mt-2 sm:mt-3">
              <svg className="w-4 h-4 sm:w-5 sm:h-5 text-white mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
              <span className="text-white font-medium mr-2 text-sm sm:text-base">{currentUser}</span>
              <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${roleInfo.bg}`}>
                {roleInfo.text}
              </span>
            </div>
          </div>
          <button 
            onClick={onLogout}
            className="px-4 sm:px-6 py-2 sm:py-3 bg-white text-red-600 rounded-lg sm:rounded-xl hover:bg-red-50 hover:shadow-xl transition-all duration-300 transform hover:scale-105 flex items-center font-semibold group w-full lg:w-auto justify-center"
          >
            <svg className="w-4 h-4 sm:w-5 sm:h-5 mr-2 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
            Déconnexion
          </button>
        </div>
      </div>
    </div>
  );
};

export default DashboardHeader;
